"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoCircleContainer = exports.IconWrapper = exports.TitleContainer = void 0;
var prism_icons_1 = require("@octanner/prism-icons");
var system_1 = require("@mui/system");
var colors_1 = require("../ThemeProvider/colors");
exports.TitleContainer = (0, system_1.styled)('div')({
    width: '200px',
});
exports.IconWrapper = (0, system_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        outline: 'none',
        '&:focus-visible': {
            outline: '3px solid #0060e0',
            outlineOffset: '3px',
            svg: {
                color: colors_1.tannerGray['600'],
            },
        },
    });
});
exports.InfoCircleContainer = (0, system_1.styled)(prism_icons_1.InformationCircle)(function (_a) {
    var theme = _a.theme;
    return ({
        color: colors_1.tannerGray['400'],
        '&:hover': {
            color: colors_1.tannerGray['600'],
        },
    });
});
//# sourceMappingURL=styles.js.map